import { EQuizId } from 'types/quiz';

const Constants = {
    SOMETHING_ELSE: 'Something else',
    INDOORS: 'INDOORS',
    OUTDOORS: 'OUTDOORS',
    INDOORS_SMALL: 'Indoors',
    OUTDOORS_SMALL: 'Outdoors',
    OTHER: 'Other',
    ALL_SEASONS: 'All Seasons',
    OPTIONS: [
        {
            label: 'Yes',
            value: 'Yes',
        },
        {
            label: 'No',
            value: 'No',
        },
    ],
    CALENDLY: 'CALENDLY',
    UPDATE_MY_STYLE_PREFERENCES: 'UPDATE MY STYLE PREFERENCES',
    UPDATE_MY_PHOTOS: 'UPDATE MY PHOTOS',
    STYLE_SESSION: 'Style Session',
    STYLE_REQUEST: 'Style Request',
    STYLE_PREFERENCES: 'Style Preferences',
    SELECT_STYLIST: 'Select Stylist',
    SELECT: 'Select',
    NO_STYLIST_AVAILABLE: 'No Stylists available at this time.',
    REQUIRED_FIELD: 'This field is required',
    PURPOSE: 'Purpose',
    PURPOSE_TITLE: 'Let us know what would you like to achieve from the style request.',
    PURPOSE_SOMETHING_ELSE_PLACEHOLDER: 'Tell us more about it to serve you better.',
    PURPOSE_OPTION_PLACEHOLDER: 'Anything else you would like to share to serve you better.',
    STYLING_SESSION_SCHEDULED: 'Styling Session Scheduled!',
    SESSION_SCHEDULED_MESSAGE:
        'In the mean time, please make sure to update your Style Preferences and Photos for the best styling services.',
    REQUEST_REQUIREMENTS_NOT_FOUND: 'Style Request Requirements not found.',
    REQUIREMENTS_NOT_AVAILABLE:
        'Sorry, the requirements you are looking for is either not available or the URL is incorrect. Please check the URL again.',
    STYLIST_NOT_FOUND_MESSAGE:
        'Sorry, the stylist you are looking for is either not available or the URL is incorrect. Please check the URL or request an expert stylist for a personalized style.',
    STYLIST_NOT_FOUND: 'Stylist Not Found.',
};

export enum SESSION_QUIZ_PATH {
    SESSION_PURPOSE = 'SESSION_PURPOSE',
    QUIZ_PATH = 'QUIZ_PATH',
    SELECT_STYLIST = 'SELECT_STYLIST',
    SELECT_SCHEDULE_TIME = 'SELECT_SCHEDULE_TIME',
    REVIEW_ORDER = 'REVIEW_ORDER',
    ORDER_SUCCESS = 'ORDER_SUCCESS',
    SESSION_SCHEDULED = 'SESSION_SCHEDULED',
    VIEW_STYLIST_DETAIL = 'VIEW_STYLIST_DETAIL',
}

export const REQUEST_PATH = {
    SESSION_PURPOSE: {
        param: 'purpose',
    },
    SESSION_LOCATION: {
        quiz: EQuizId.SESSION_LOCATION_QUIZ,
        param: 'location',
    },
    SESSION_SEASON: {
        quiz: EQuizId.SESSION_SEASON_QUIZ,
        param: 'season',
    },
    SESSION_ENVIRONMENT: {
        quiz: EQuizId.SESSION_ENVIRONMENT_QUIZ,
        param: 'environment',
    },
    SESSION_THEME: {
        quiz: EQuizId.SESSION_THEME,
        param: 'theme',
    },
    SESSION_STYLE_PREFERENCES: {
        quiz: EQuizId.SESSION_STYLE_PREFERENCES_QUIZ,
        param: 'style-preferences',
    },
    SESSION_FOCUS: {
        quiz: EQuizId.SESSION_FOCUSED_ITEMS_QUIZ,
        param: 'focus',
    },
    SESSION_EXPECTED: {
        quiz: EQuizId.SESSION_EXPECTED_ITEMS_QUIZ,
        param: 'expected-items',
    },
    SESSION_WARDROBE: {
        quiz: EQuizId.SESSION_WARDROBE_QUIZ,
        param: 'wardrobe',
    },
    SESSION_MIX_AND_MATCH: {
        quiz: EQuizId.SESSION_MIX_AND_MATCH_QUIZ,
        param: 'mix-and-match',
    },
    SELECT_STYLIST: {
        param: 'select-stylist',
    },
    SELECT_SCHEDULE_TIME: {
        param: 'select-schedule-time',
    },
    REVIEW_ORDER: {
        param: 'review-order',
    },
    ORDER_SUCCESS: {
        param: 'order-success',
    },
    SESSION_SCHEDULED: {
        param: 'session-scheduled',
    },
    VIEW_STYLIST_DETAIL: {
        param: 'view-stylist-detail',
    },
};

export default Constants;
